import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE, PERMISSION } from "@supplier/meta";
import { UserStore } from "@/stores/user";
import { AccountStore, AccountType } from "@/stores/account";

const aiRiskControlRouter: RouteRecordRaw[] = [
    {
        path: "/aiRiskControl",
        name: "AiRiskControl",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/aiRiskControl/dashboard",
        meta: {
            title: "风控管理",
            icon: "icon-AI",
            hidden: ({ userStore, accountStore }: { userStore: UserStore; accountStore: AccountStore }) => {
                // 子账号需要有风控专员权限
                if (accountStore.accountType === AccountType.SUB_ACCOUNT) {
                    const permissions = userStore.userInfo.permissions || [];
                    return !permissions.includes(PERMISSION.RISK_CONTROL.code);
                }
                return false;
            }
        },
        children: [
            {
                path: "/aiRiskControl/warehouseSupervision",
                name: "AiWarehouseSupervision",
                component: () => import("@/views/pages/aiRiskControl/warehouseSupervision/index.vue"),
                meta: {
                    title: "仓库监管",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            }
        ]
    }
];

export default aiRiskControlRouter;
